import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";
import logo from "../data/logo1.png";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/#about", label: "About" },
  { to: "/#events", label: "Events" },
  { to: "/#gallery", label: "Gallery" },
  { to: "/#reviews", label: "Reviews" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-inner container">
        <Link
          to="/"
          className="brand"
          aria-label="Zafwa Royale Events home"
          onClick={closeMenu}
        >
          <img
            src={logo}
            alt="Zafwa Royale Events"
            loading="lazy"
            className="brand-logo "
          />

          <span className="brand-text">
            <span className="brand-name">Zafwa Royale</span>
            <span className="brand-sub">Events Management LLC</span>
          </span>
        </Link>

        <nav className={`main-nav ${menuOpen ? "open" : ""}`}>
          {NAV_LINKS.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className="nav-link"
              onClick={closeMenu}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/#contact" className="nav-link nav-cta" onClick={closeMenu}>
            Contact Us
          </Link>
        </nav>

        <button
          className={`hamburger ${menuOpen ? "open" : ""}`}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}
